const hideItemsWithAccounts = [{ id: 38880, itemsName: ['Sách điện tử (offline)'], itemsPath: ['/teacher/files', '/education-game'] }];

type HideSidebarWithAccountProps = {
  id: number;
  routeItemName?: string;
  routeItemPath?: string;
};

const HideSidebarWithAccount = ({ id, routeItemName, routeItemPath }: HideSidebarWithAccountProps) => {
  const isExist = hideItemsWithAccounts.find((x) => x.id === id);
  if (isExist && routeItemName && isExist.itemsName.some((x) => x === routeItemName)) {
    return true;
  }
  if (isExist && routeItemPath && isExist.itemsPath.some((x) => x === routeItemPath)) {
    return true;
  }
  return false;
};

export default HideSidebarWithAccount;
